var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":_vm.toggle}},[_vm._t("collapsed",null,{"expanded":_vm.expanded})],2),_vm._v(" "),(_vm.expanded)?_c('div',{staticClass:"flex"},[_vm._t("expanded")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }